export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_RESULT = 'FORGOT_PASSWORD_RESULT';
export const FORGOT_PASSWORD_CONFIRM_RESULT = 'FORGOT_PASSWORD_CONFIRM_RESULT';

export const FORGOT_PASSWORD_FORGOT_PASSWORD_OPEN_MODAL = 'FORGOT_PASSWORD_FORGOT_PASSWORD_OPEN_MODAL';
export const FORGOT_PASSWORD_FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_FORGOT_PASSWORD_RESULT = 'FORGOT_PASSWORD_FORGOT_PASSWORD_RESULT';

export const FORGOT_PASSWORD_CONFIRM_FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_CONFIRM_FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_CONFIRM_FORGOT_PASSWORD_RESULT = 'FORGOT_PASSWORD_CONFIRM_FORGOT_PASSWORD_RESULT';

export const FORGOT_PASSWORD_CHECK_LOGIN_USER_BY_CODE = 'FORGOT_PASSWORD_CHECK_LOGIN_USER_BY_CODE';

export const FORGOT_PASSWORD_CHANGE_PASSWORD_OPEN_MODAL = 'FORGOT_PASSWORD_CHANGE_PASSWORD_OPEN_MODAL';
export const FORGOT_PASSWORD_CHANGE_PASSWORD_REQUEST = 'FORGOT_PASSWORD_CHANGE_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_CHANGE_PASSWORD_RESULT = 'FORGOT_PASSWORD_CHANGE_PASSWORD_RESULT';